module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0082.png.20b539f6.jpg";